export default __webpack_public_path__ + "static/media/1.cfa9e88d.jpg";